import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import axios from "axios";
import { axiosErrorHandler } from "../../../../../swzutils";
import React, { useImperativeHandle, useState } from "react";
import { CurrencyFormat } from "../../../components/FormattersTS";
import { Spin } from "antd";
import HelpLabel from "../../../components/HelpLabel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTruck } from '@fortawesome/free-solid-svg-icons/faTruck';
const VehicleHireEarningsWidget = (props, exportedRef) => {
    const [stateLoading, setStateLoading] = useState(false);
    const [stateData, setStateData] = useState(null);
    useImperativeHandle(exportedRef, () => {
        return {
            refresh
        };
    });
    // useEffect(() => {
    //     refresh()
    // }, []);
    const refresh = () => {
        loadVehicleHireEarnings();
    };
    const loadVehicleHireEarnings = () => {
        setStateLoading(true);
        axios.get(`/admin/v1/dashboard/vehicle-hire-earnings/${props.date}`)
            .then(response => {
            setStateData(response.data);
        }).catch(error => {
            setStateData(null);
            axiosErrorHandler(error);
        }).finally(() => {
            setStateLoading(false);
        });
    };
    const totalCalcPaymentAmount = stateData?.totalCalcPaymentAmount;
    return (_jsx(Spin, { spinning: stateLoading, children: _jsxs("div", { className: "widget", children: [_jsx("div", { className: "widget-icon widget-icon-dk-blue", children: _jsx(FontAwesomeIcon, { icon: faTruck }) }), totalCalcPaymentAmount
                    ? _jsx("h2", { className: "widget-value", children: _jsx(CurrencyFormat, { value: totalCalcPaymentAmount, roundToDollars: true }) })
                    : _jsx("h2", { className: "widget-value", children: "\u2014" }), _jsx("p", { children: _jsx(HelpLabel, { title: "Est. vehicle hire earnings", helpText: _jsx("p", { children: "An estimate of the earnings you will get from vehicles hire requests.  If all hires have been completed then this value is an accurate earnings otherwise it's an estimate as specified in the request." }) }) })] }) }));
};
export default React.forwardRef(VehicleHireEarningsWidget);
